import React from "react";
import {
  AccountCircleOutlined,
  HomeOutlined,
  PersonOutline,
  SchoolOutlined,
} from "@material-ui/icons";
import { useParent } from "../../../../context/ParentContext";
import { baseUrl } from "../../../../services/config";
import "./student-profile.css";

const firstValue = (...values) =>
  values.find(
    (value) => value !== undefined && value !== null && String(value).trim(),
  );

function ProfileDetail({ label, value }) {
  return (
    <div className="parent-profile-detail">
      <span>{label}</span>
      <strong>{value || "Not available"}</strong>
    </div>
  );
}

function ProfileSection({ icon: Icon, title, children }) {
  return (
    <section className="parent-profile-section">
      <header>
        <span className="parent-profile-section-icon">
          <Icon />
        </span>
        <h2>{title}</h2>
      </header>
      <div className="parent-profile-details">{children}</div>
    </section>
  );
}

export default function StudentProfile() {
  const { selectedChild } = useParent();

  if (!selectedChild) {
    return (
      <section className="parent-profile-page">
        <div className="parent-profile-empty">
          <PersonOutline />
          <h1>No student selected</h1>
          <p>Select a child from the navbar to view their profile.</p>
        </div>
      </section>
    );
  }

  // Parent-login responses may keep relationship fields on the child record
  // and student fields in a nested object. Combining both supports either shape.
  const student = { ...selectedChild, ...(selectedChild.student || {}) };
  const studentName = firstValue(student.name, student.student_name, "Student");
  const className = firstValue(
    student.student_class?.name,
    student.student_class_name,
    selectedChild.student_class?.name,
  );
  const sectionName = firstValue(
    student.global_section?.name,
    student.section?.name,
    student.global_section_name,
    student.section_name,
  );
  const studentId = firstValue(
    student.admission_id,
    student.registration_id,
    student.roll_no,
  );
  const studentPictureUrl = selectedChild?.student?.picture
    ? `${baseUrl.replace(/\/api\/?$/, "")}/storage/student/${
        selectedChild.student.picture
      }`
    : "";
  const initials = String(studentName)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");

  return (
    <section className="parent-profile-page">
      <div className="parent-profile-hero">
        <div className="parent-profile-avatar">
          <span aria-hidden="true">{initials || <PersonOutline />}</span>
          {studentPictureUrl && (
            <img
              key={studentPictureUrl}
              src={studentPictureUrl}
              alt={`${studentName} profile`}
              onError={(event) => {
                event.currentTarget.style.display = "none";
              }}
            />
          )}
        </div>
        <div>
          <span className="parent-profile-eyebrow">Student profile</span>
          <h1>{studentName}</h1>
          <p>
            {[className, sectionName].filter(Boolean).join(" · ") ||
              "Academic information"}
          </p>
        </div>
        {studentId && (
          <div className="parent-profile-id">
            <span>
              {student.admission_id ? "Admission ID" : "Registration ID"}
            </span>
            <strong>{studentId}</strong>
          </div>
        )}
      </div>

      <div className="parent-profile-grid">
        <ProfileSection icon={AccountCircleOutlined} title="Personal details">
          <ProfileDetail label="Full name" value={studentName} />
          <ProfileDetail label="Date of birth" value={student.dob} />
          <ProfileDetail label="Gender" value={student.gender} />
          {/* <ProfileDetail
            label="Mobile number"
            value={firstValue(student.mobile_no, student.phone, student.contact_no)}
          /> */}
          <ProfileDetail label="Address" value={student.address} />
          <ProfileDetail
            label="Joining date"
            value={firstValue(student.Joining_date, student.joining_date)}
          />
        </ProfileSection>

        <ProfileSection icon={SchoolOutlined} title="Academic details">
          <ProfileDetail
            label="Campus"
            value={firstValue(student.campus?.name)}
          />
          <ProfileDetail label="Class" value={className} />
          <ProfileDetail label="Section" value={sectionName} />
          <ProfileDetail label="Admission ID" value={student.admission_id} />
          <ProfileDetail
            label="Registration ID"
            value={student.registration_id}
          />
        </ProfileSection>

        <ProfileSection icon={PersonOutline} title="Guardian details">
          <ProfileDetail
            label="Father / guardian name"
            value={firstValue(student.father_name, student.guardian_name)}
          />
          <ProfileDetail label="Father CNIC" value={student.father_cnic} />
          <ProfileDetail
            label="Guardian contact"
            value={firstValue(
              student.mobile_no,
              student.guardian_mobile_no,
              student.parent_mobile_no,
            )}
          />
        </ProfileSection>

        {/* <ProfileSection icon={HomeOutlined} title="Contact details">
          <ProfileDetail label="Address" value={student.address} />
          <ProfileDetail label="City" value={student.city} />
          <ProfileDetail label="Province" value={student.province} />
        </ProfileSection> */}
      </div>
    </section>
  );
}
